export const SET_ACTIVE_SERVICE_CENTER = 'SET_ACTIVE_SERVICE_CENTER';

export const GET_IS_DECIMAL_REQUEST = 'GET_IS_DECIMAL_REQUEST';
export const GET_IS_DECIMAL_SUCCESS = 'GET_IS_DECIMAL_SUCCESS';
export const GET_IS_DECIMAL_FAILURE = 'GET_IS_DECIMAL_FAILURE';

